import React, { ReactElement, useEffect, useState } from "react";
import { Menu02 } from "@untitled-ui/icons-react";
import { HeaderAsideDrawer } from "../asideDrawer";
import {
  DisplayOnDesktop,
  DisplayOnMobile,
  eventBus,
} from "@kunduz/utility-common";
import styles from "./mainNavigation.module.scss";

export const HeaderMainNavigation = (props: Props): ReactElement => {
  const [asideVisible, setAsideVisible] = useState(false);

  useEffect(() => {
    if (!eventBus) return;

    function hamburgerClickedCallback() {
      setAsideVisible(!asideVisible);
    }

    eventBus.on("hamburgerClicked", hamburgerClickedCallback);

    return () => {
      eventBus.off("hamburgerClicked", hamburgerClickedCallback);
    };
  }, [eventBus]);

  useEffect(() => {
    setAsideVisible(false);
  }, [props.currentPath]);

  return (
    <>
      <nav className={styles.wrapper}>
        <div className={styles.mainNav}>
          <div className={styles.container}>
            <div className={styles.content}>
              <button
                onClick={() => setAsideVisible(!asideVisible)}
                className={styles.hamburgerButton}
              >
                <Menu02 />
              </button>
              <div>{props.logoComponent}</div>
              <div className={styles.desktopMenuWrapper}>
                {props.desktopLeftComponent}
              </div>
            </div>

            <div className={styles.desktopCtaWrapper}>
              <DisplayOnDesktop>{props.desktopRightComponent}</DisplayOnDesktop>
              <DisplayOnMobile>{props.mobileRightComponent}</DisplayOnMobile>
            </div>
          </div>
        </div>
      </nav>

      <HeaderAsideDrawer
        visible={asideVisible}
        onBackdropClicked={() => setAsideVisible(false)}
      >
        {props.mobileLogoComponent}
        {props.mobileTopComponent}
        {props.mobileBottomComponent}
      </HeaderAsideDrawer>
    </>
  );
};

interface Props {
  logoComponent: JSX.Element;
  desktopLeftComponent: JSX.Element;
  desktopRightComponent: JSX.Element | JSX.Element[];
  mobileRightComponent: JSX.Element | JSX.Element[];
  mobileLogoComponent: JSX.Element;
  mobileTopComponent: JSX.Element;
  mobileBottomComponent: JSX.Element;
  currentPath: string;
}
